import { render } from "./ArticleSecondary.vue?vue&type=template&id=11a37166&scoped=true"
import script from "./ArticleSecondary.vue?vue&type=script&lang=js"
export * from "./ArticleSecondary.vue?vue&type=script&lang=js"

import "./ArticleSecondary.vue?vue&type=style&index=0&id=11a37166&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11a37166"]])

export default __exports__